import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadMultiFile
} from "../../Lib/componentLibrarys";
import Api from "../../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";

export const FormNhap = ({ values, errors, setFieldValue }) => {
  const [phuongXaList, setPhuongXaList] = useState([]);
  const [quanHuyenList, setQuanHuyenList] = useState([]);
  const [tinhThanhList, setTinhThanhList] = useState([]);

  const getApiListDvhc = (cap, madvhc, setData) => {
    new Api()
      .GetListDvhc({ cap: cap, madvhc: madvhc })
      .then(data => {
        if (data.code === 200) {
          setData(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={4}>
          <FastField name="ngay">
            {({ field }) => (
              <MyTextField
                required
                type="number"
                label="Ngày thống kê:"
                placeholder="Nhập..."
                errors={errors?.ngay}
                helperText={errors?.ngay}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={4}>
          <FastField name="thang">
            {({ field }) => (
              <MyTextField
                required
                type="number"
                label="Tháng thống kê:"
                placeholder="Nhập..."
                errors={errors?.thang}
                helperText={errors?.thang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={4}>
          <FastField name="nam">
            {({ field }) => (
              <MyTextField
                required
                type="number"
                label="Năm thống kê:"
                placeholder="Nhập..."
                errors={errors?.nam}
                helperText={errors?.nam}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Tỉnh thành:"
            placeholder="Chọn..."
            value={values?.tinhThanh}
            options={tinhThanhList}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`tinhThanh`, value);
              setFieldValue(`quanHuyen`, null);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              isEmpty(tinhThanhList) && getApiListDvhc(1, "", setTinhThanhList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Quận huyện:"
            placeholder="Chọn..."
            value={values?.quanHuyen}
            options={quanHuyenList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`quanHuyen`, value);
              setFieldValue(`phuongXa`, null);
            }}
            onOpen={() => {
              values?.tinhThanh?.maTinh &&
                getApiListDvhc(2, values.tinhThanh.maTinh, setQuanHuyenList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Phường xã:"
            placeholder="Chọn..."
            value={values?.phuongXa}
            options={phuongXaList || []}
            name="tenDVHC"
            onChange={(event, value) => {
              setFieldValue(`phuongXa`, value);
            }}
            onOpen={() => {
              values?.quanHuyen?.maHuyen &&
                getApiListDvhc(3, values.quanHuyen.maHuyen, setPhuongXaList);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="nhietDo">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Nhiệt độ "
                measure={
                  <span>
                    (<sup>o</sup>C):
                  </span>
                }
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="luongMua">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Lượng mưa (mm):"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="doAm">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Độ ẩm (%):"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="soGioNang">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Số giờ nắng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
